import React, { useEffect } from 'react';
import './Cards.css';
import CardItem from './CardItem';
import ScrollToTop from "./ScrollToTop";

function Cards({ projects }) {  // Receive the projects prop
  useEffect(() => {
    const cardItems = document.querySelectorAll('.cards__item');

    const handleScroll = () => {
      cardItems.forEach(item => {
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          item.classList.add('show');
        } else {
          item.classList.remove('show');
        }
      });
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='cards'>
      <div className='cards__container'>
        <h1 className="md:text-2xl text-xl text-center mb-4">CHECK OUT OUR PROJECTS.</h1>
        <div className="grid lg:grid-cols-6 lg:auto-rows-[45rem] cards__wrapper gap-4">
          {projects.map((project, index) => {
            const isFirstRow = Math.floor(index / 2) % 2 === 0;
            const colSpan = index % 2 === 0 ? (isFirstRow ? "lg:col-span-2" : "lg:col-span-4") : (isFirstRow ? "lg:col-span-4" : "lg:col-span-2");

            return (
              <div key={index} className={`cards__items ${colSpan}`}>
                <CardItem
                  src={`images/${project.projectId}/${project.images[0]}`}
                  text={project.detail.client}
                  label={project.detail.category}
                  path={`/projects/${project.projectId}`}
                />
              </div>
            );
          })}
        </div>
        <ScrollToTop />
      </div>
    </div>
  );
}

export default Cards;

